import Http from '../../http';

export const fetchCustomer = id => Http.get(`/customer/${id}`);

export const mergeCustomers = (survivingCustomerId, duplicateCustomerId) =>
  Http.post('/customer/merge', { survivingCustomerId, duplicateCustomerId });
